export default __webpack_public_path__ + "static/media/youtubeCompany.0f23fcbf.svg";